<template>
  <div
    v-if="subscriber.isLogged"
    v-accessibility-focus="showProfiles"
    class="o-typography--action c-navigation-drawer__item u-uppercase"
  >
    <v-avatar
      :profile="subscriber.profile"
      :edit="false"
      class="c-profiles-avatar--extra-small"
    ></v-avatar>
    <span>
      {{ subscriber.profile.name }}
    </span>
  </div>
  <router-link
    v-else
    :event="$route.name !== RouteName.SUBSCRIBER_LOGIN ? 'click' : ''"
    :to="{ name: RouteName.SUBSCRIBER_LOGIN, query: { redirect: $route.fullPath }}"
    class="o-typography--action c-navigation-drawer__item"
  >
    <i class="o-icon o-icon--user"></i>
    <span>{{ $t('common.signIn') }}</span>
  </router-link>
</template>
<script>
  import { RouteName } from '@/shared/enums';
  import { VAvatar } from '@/index/shared/components';

  export default {
    components: {
      VAvatar,
    },
    enums: {
      RouteName,
    },
    data() {
      return {
        subscriber: this.$services.resolve('subscriber'),
      };
    },
    methods: {
      showProfiles() {
        this.$emit('showProfiles', { editMode: false });
      },
    },
  };
</script>
